import styled, { css } from 'styled-components';
import theme from 'styles/theme';

export const SiteAccessCardStyled = styled.div`
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  margin-bottom: 20px;
  overflow: hidden;
`;

export const UpgradeBannerStyled = styled.div`
  align-items: center;
  background: #eef0fb;
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  justify-content: space-between;
  padding: 16px 20px;

  h4 {
    font-weight: 700;
    margin: 0 0 6px;
  }

  p {
    color: #6b7280;
    margin: 0 0 4px;
  }

  a {
    color: ${theme.colors.hostfullyPurple};
  }

  .btn {
    flex-shrink: 0;
  }
`;

export const BannerLinksStyled = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
`;

export const BannerLoaderStyled = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 8px;
`;

export const SiteRowStyled = styled.div<{ $isInline?: boolean }>`
  padding: 20px;

  h4 {
    font-weight: 700;
    margin: 0 0 12px;
  }

  ${({ $isInline }) =>
    $isInline &&
    css`
      align-items: center;
      display: flex;
      gap: 16px;
      justify-content: space-between;
    `}
`;

export const SiteLabelStyled = styled.p`
  font-weight: 700;
  margin: 0;
`;

export const SiteButtonsStyled = styled.div`
  display: flex;
  flex-shrink: 0;
  gap: 12px;
`;
